var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInVoice = function SvgInVoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.979,
    height: 20,
    viewBox: "0 0 14.979 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#818e94;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.497 3.138)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M200.833,84.1H200a.669.669,0,0,1,0-1.339h1.674a.586.586,0,1,0,0-1.172H201V80.92a.586.586,0,0,0-1.172,0V81.6A1.841,1.841,0,0,0,200,85.271h.837a.669.669,0,0,1,0,1.339h-1.674a.586.586,0,0,0,0,1.172h.669v.669a.586.586,0,1,0,1.172,0v-.677a1.841,1.841,0,0,0-.167-3.674Z",
    transform: "translate(-198.155 -80.334)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.033 13.807)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M167.529,353.467h-6.276a.586.586,0,1,0,0,1.172h6.276a.586.586,0,0,0,0-1.172Z",
    transform: "translate(-160.667 -353.467)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.66,0H64.853a.586.586,0,0,0-.586.586v17.1a.586.586,0,0,0,.172.414l1.726,1.726a.586.586,0,0,0,.829,0L68.3,18.517l1.312,1.312a.586.586,0,0,0,.829,0l1.312-1.312,1.312,1.312a.586.586,0,0,0,.829,0l1.312-1.312,1.312,1.312a.586.586,0,0,0,.829,0L79.075,18.1a.586.586,0,0,0,.172-.414V.586A.586.586,0,0,0,78.66,0ZM76.934,18.585l-1.312-1.312a.586.586,0,0,0-.829,0l-1.312,1.312-1.312-1.312a.586.586,0,0,0-.829,0l-1.312,1.312-1.312-1.312a.586.586,0,0,0-.829,0l-1.312,1.312-1.14-1.14V1.172H78.074V17.445h0Z",
    transform: "translate(-64.267)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInVoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in_voice.374f5556.svg";
export { ForwardRef as ReactComponent };